import React from 'react';
import { Col, Layout, Row } from 'antd';
import NumberCard from './NumberCard';
import PieCard from './pieCard';
import CountryCard from './countryCard';
const { Content } = Layout;

const topColResponsiveProps = {
  xs: 24,
  sm: 12,
  md: 12,
  lg: 12,
  xl: 6,
  style: { marginBottom: 24 },
};

function Dashboard(props) {
  return (
    <Content style={{ margin: '24px 24px 0' }}>

      <Row gutter={24} type="flex">
        <Col {...topColResponsiveProps}>
          <NumberCard title="Total Objects" urlPath="object-count" />
        </Col>
        <Col {...topColResponsiveProps}>
          <NumberCard title="Unavailable Objects" urlPath="unavailable-objects" />
        </Col>
        <Col {...topColResponsiveProps}>
          <NumberCard title="Objects with Label" urlPath="curatorial-label" />
        </Col>
        <Col {...topColResponsiveProps}>
          <NumberCard title="Objects Loaned" urlPath="insurance-count" />
        </Col>
      </Row>

      <Row gutter={24} type="flex">
        <Col span={6}>
          <CountryCard />
        </Col>
        <Col span={18}>
          <PieCard />
        </Col>
      </Row>

      <Row gutter={24} type="flex"  style={{ marginTop: '1em' }}>
        <Col {...topColResponsiveProps}>
          <NumberCard title="Objects with Photo" urlPath="objects-with-photos" />
        </Col>
        <Col {...topColResponsiveProps}>
          <NumberCard title="Objects with Condition" urlPath="condition-object-count" />
        </Col>

        <Col {...topColResponsiveProps}>
          <NumberCard title="Objects with Curatorial" urlPath="curatorial-object-count" />
        </Col>
        <Col {...topColResponsiveProps}>
          <NumberCard title="Objects with Technical" urlPath="technical-object-count" />
        </Col>

        <Col {...topColResponsiveProps}>
          <NumberCard title="Objects In Treatment" urlPath="treatment-object-count" />
        </Col>
        <Col {...topColResponsiveProps}>
          <NumberCard title="Objects Moved" urlPath="movement-object-count" />
        </Col>
        <Col {...topColResponsiveProps}>
          <NumberCard title="Objects in Bad Condition" urlPath="objects-in-bad-condition" />
        </Col>
      </Row>


    </Content>

  );
}

export default Dashboard;
